import React from 'react'

import { modalSelector } from '@ui-kit/components/ModalSelector/styles'
import { textColor } from '@ui-kit/styles/colors'

import type { WebProps } from './types'

const ModalSelector = (props: WebProps) => {
  const { button, text } = modalSelector({
    disabled: props.disabled,
    isSmall: props.isSmallButton,
  })
  return (
    <button
      id={`${props.id}-Button`}
      data-testid={`${props.id}-Button`}
      type="button"
      disabled={props.disabled}
      onClick={props.onClick}
      style={{ backgroundColor: props.backgroundColor }}
      className={button({ className: textColor({ color: props.textColor ?? 'brandDark' }) })}
    >
      <span className={text({ className: textColor({ color: props.textColor ?? 'brandDark' }) })}>
        {props.label}
      </span>
      {!props.disabled ? (
        <svg
          width="11"
          height="7"
          viewBox="0 0 11 7"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path d="M1.5 1L5.5 5L9.5 1" stroke="currentColor" strokeWidth="1.5" />
        </svg>
      ) : null}
    </button>
  )
}

export default ModalSelector
